module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.news.red-47fab05ac8656002685fe5088e1ef3a9.svg";